import { ExpedienteCentro, HorarioDia } from '../types/centro.types';

export const ESTATUS_OPCIONES = [
    { id: 'ACTI', label: 'Activo', color: 'success' },
    { id: 'PEND', label: 'En revisión / Nuevo', color: 'primary' },
    { id: 'REVI', label: 'A prueba (Bajo rendimiento)', color: 'warning' },
    { id: 'BLOQ', label: 'Bloqueado', color: 'danger' },
    { id: 'CANC', label: 'Eliminado / Dado de baja', color: 'secondary' },
] as const;

export const DIAS_SEMANA = [
    { id: '1', nombre: 'Lunes' },
    { id: '2', nombre: 'Martes' },
    { id: '3', nombre: 'Miércoles' },
    { id: '4', nombre: 'Jueves' },
    { id: '5', nombre: 'Viernes' },
    { id: '6', nombre: 'Sábado' },
    { id: '7', nombre: 'Domingo' },
] as const;

const generateHoras = (): string[] => {
    const horas: string[] = [];
    for (let i = 0; i < 24; i++) {
        const h = i < 10 ? `0${i}` : `${i}`;
        horas.push(`${h}:00`, `${h}:30`);
    }
    return horas;
};

export const HORAS = generateHoras();

export const defaultHorarios: HorarioDia[] = DIAS_SEMANA.map((d) => ({
    id_dia: d.id,
    activo: ['1', '2', '3', '4', '5'].includes(d.id),
    hora_inicio: '09:00',
    hora_fin: '18:00',
}));

export const defaultExpediente: ExpedienteCentro = {
    personal_gerente_servicio: false,
    personal_jefe_taller: false,
    personal_asesor_servicio: false,
    personal_asistente_servicio: false,
    personal_tecnicos: false,
    personal_pintor: false,
    personal_spotter: false,
    personal_hojalatero: false,
    instalacion_rampas_servicio: '',
    instalacion_sitios_productivos: '',
    instalacion_alineacion_balanceo: false,
    instalacion_recepcion: false,
    instalacion_estacionamiento: false,
    instalacion_sala_espera: false,
    instalacion_camaras_seguridad: false,
    instalacion_seguro_rc: false,
    instalacion_altura_libre_grua: false,
    instalacion_vigilancia_24h: false,
    instalacion_recepcion_grua: false,
    instalacion_area_lavado: false,
    instalacion_estetica_automotriz: false,
    equipo_camara_pintura: false,
    equipo_banco_enderezado: false,
    equipo_laboratorio_color: false,
    equipo_rampa_diagnostico: false,
    horario_recepcion_grua: '',
    salida_mismo_dia: false,
};

export const PERSONAL_EXPEDIENTE_FIELDS = [
    'personal_gerente_servicio',
    'personal_jefe_taller',
    'personal_asesor_servicio',
    'personal_asistente_servicio',
    'personal_tecnicos',
    'personal_pintor',
    'personal_spotter',
    'personal_hojalatero',
] as const;

export const INSTALACION_EXPEDIENTE_FIELDS = [
    'instalacion_alineacion_balanceo',
    'instalacion_recepcion',
    'instalacion_estacionamiento',
    'instalacion_sala_espera',
    'instalacion_camaras_seguridad',
    'instalacion_seguro_rc',
    'instalacion_altura_libre_grua',
    'instalacion_vigilancia_24h',
    'instalacion_recepcion_grua',
    'instalacion_area_lavado',
    'instalacion_estetica_automotriz',
] as const;

export const EQUIPO_EXPEDIENTE_FIELDS = [
    'equipo_camara_pintura',
    'equipo_banco_enderezado',
    'equipo_laboratorio_color',
    'equipo_rampa_diagnostico',
] as const;

export const GOOGLE_MAPS_API_KEY = 'AIzaSyDt6DnX6Kx4kKx4bg9_K-TdYfhWtyWQm2U';

export const DEFAULT_MAP_CENTER = { lat: 25.6866, lng: -100.3161 };

export const createInitialFormData = (preProveedorId = ''): import('../types/centro.types').CentroFormData => ({
    clave_persona_proveedor: preProveedorId,
    sucursal: '',
    clave_tipo_centro: '',
    rfc: '',
    clave_periodo_pago: '',
    enum_forma_pago: '',
    clave_banco: '',
    clabe: '',
    banco: '',
    clave_estatus: 'ACTI',
    asesor: '',
    telefono: '',
    email: '',
    contacto_administracion_nombre: '',
    contacto_administracion_telefono: '',
    contacto_administracion_correo: '',
    contacto_facturacion_nombre: '',
    contacto_facturacion_telefono: '',
    contacto_facturacion_correo: '',
    horarios: defaultHorarios,
    servicios: [],
    expediente: defaultExpediente,
    asignacion_automatica: false,
    direccion: '',
    clave_estado: '',
    clave_ciudad: '',
    lat: '',
    lng: '',
    radio: 45,
});
